module.exports = __webpack_public_path__ + "img/press-19.a25713aa.jpg";